import React from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const tabs = [
  { name: 'expenses', label: '経費', path: '/expenses' },
  // { name: 'purchases', label: '商品原価', path: '/purchases' },
];

export default function ExpenseTabs({ activeTab }) {
  return (
    <Nav tabs className="mb-3">
      {tabs.map(({ label, name, path }) => (
        <NavItem key={name}>
          <Link 
            className={classnames('nav-link cursor-pointer', { active: activeTab === name })}
            to={path}
          >
            {label}
          </Link>
        </NavItem>
      ))}
    </Nav>
  );
}
